/* App-screen ids ⇄ URLs — shared by ZuzuRedesign (nav callbacks, zz-nav
   listener) and ZuzuAppRuntime (booking/auth flows), which live in different
   chunks, so the map gets its own module rather than a home in either. */
export const APP_PATHS: Record<string, string> = {
  auth: "/auth",
  // Signed-out "resend my verification email" screen (WaAuth's unverified
  // mode) — linked from the failed sign-in, the sign-in sheet and the
  // post-signup confirm screen.
  verifyEmail: "/auth/verify",
  // Password reset, on its own URL so the website's log-in step (and anything
  // else outside the sheet) can link straight to it.
  forgotPassword: "/auth/forgot",
  today: "/dashboard",
  // The day's booking calendar — the same timeline that runs on the screen at
  // the door: everything booked today, by initials. A full-screen page outside
  // the app shell, so it carries its own way back (see DoorDisplay).
  calendar: "/door",
  browse: "/app/equipment",
  stack: "/bookings",
  // The list of bookings a member already has, as opposed to `stack`, which is
  // the picker for making a new one. In-app navigation reaches the list as a
  // sub-screen of whatever is on screen (see WebApp's nav), so this URL exists
  // for links from OUTSIDE the app — the confirmation email's "manage your
  // booking", which used to land on /bookings and show the picker, with no
  // sign of the booking it was talking about.
  bookings: "/my-bookings",
  session: "/session",
  wallet: "/wallet",
  plans: "/plans",
  profile: "/profile",
};
